module.exports = __webpack_public_path__ + "img/picto_wine.c2e7a506.png";